import { photoLayer, bbsSatelite, eestiPhotoLayer } from './mapLayers';
import { SATELITE_MAP_LEVEL } from './reducer';


export default function({map}) {
    
    var currZoom = map.getView().getZoom();

    var setLayers = (zoom, force = false) => {

        /* if(force || (!bbsSatelite.getVisible() && SATELITE_MAP_LEVEL > zoom)) {

            photoLayer.setVisible(false);
            eestiPhotoLayer.setVisible(false);
            bbsSatelite.setVisible(true);
        } else if(bbsSatelite.getVisible() && SATELITE_MAP_LEVEL <= zoom){

            photoLayer.setVisible(true);
            eestiPhotoLayer.setVisible(true);
            bbsSatelite.setVisible(false);
        } */
    }

    setLayers(currZoom, true);

    map.on('moveend', function(e) {

      var newZoom = map.getView().getZoom();

      if (currZoom != newZoom) {
        
        setLayers(newZoom);

        currZoom = newZoom;
      }
    });
}